import BaseApiService from '../base/BaseApiService';
import type {
  ReferenceList,
  UpdateReferenceListLabelsRequest,
} from '@app-types/reference-list';

class ReferenceListService extends BaseApiService {
  async getCatalog(): Promise<ReferenceList[]> {
    return this.get<ReferenceList[]>('/reference-lists');
  }

  async getAll(): Promise<ReferenceList[]> {
    return this.get<ReferenceList[]>('/admin/reference-lists');
  }

  async getByKey(key: string): Promise<ReferenceList> {
    return this.get<ReferenceList>(`/admin/reference-lists/${encodeURIComponent(key)}`);
  }

  async updateLabels(
    key: string,
    data: UpdateReferenceListLabelsRequest,
  ): Promise<ReferenceList> {
    return this.put<ReferenceList>(
      `/admin/reference-lists/${encodeURIComponent(key)}`,
      data,
    );
  }
}

export const referenceListService = new ReferenceListService();
